import { render, staticRenderFns } from "./FormatText.vue?vue&type=template&id=6f7a9aab"
import script from "./FormatText.vue?vue&type=script&lang=js"
export * from "./FormatText.vue?vue&type=script&lang=js"
import style0 from "./FormatText.vue?vue&type=style&index=0&id=6f7a9aab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports